var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-30"},[_c('newsletter-component'),_c('footer-top-component'),_c('footer-bottom-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }